import React, { useEffect, useState } from "react";

import { SwitchComponent } from "@syncfusion/ej2-react-buttons";
import { InPlaceEditorComponent } from "@syncfusion/ej2-react-inplace-editor";
import AvailabilityTemplate from "../../../../grid_templates/availabilityTemplate";
import EligibilityTemplate from "../../../../grid_templates/eligibilityTemplate";
import DevAssessement from "./DevAssessement";
import { CircularProgress } from "@mui/material";
// import emptAssImg from "";

// Props are comming from the devProfile.js file
const CrossPlatform = (props) => {
  const [isLeadOn, setIsLeadOn] = useState(false);

  useEffect(() => {
    setIsLeadOn(props.dev?.leadTime?.leadTimeOn ?? false);
  }, [props.dev?.leadTime?.leadTimeOn]);
  // console.log("props?.assessments", props?.assessments);
  return (
    <div
      className="account-leadData"
      style={{
        marginTop: "2rem",
      }}
    >
      <div className="account-leadData_empty"></div>
      <div className="account-leadData_switches">
        <div className="_spDevPage--assessement">
          {props?.dev?.profileAssessments?.length > 0 &&
          props?.assessments?.length > 0 ? (
            <DevAssessement
              data={props?.assessments}
              userRef={props?.dev?.userRef}
              showScore={false}
              showRate={true}
              showDifficulty={false}
            />
          ) : (
            <div className="_spDevPage--assessement-empty">
              <h3>YOUR VIDEO PROFILE</h3>
              <div className="_spDevPage--assessement-empty__infos">
                <div className="_spDevPage--assessement-empty__infos_imgWrapper">
                  <img src="/images/assEmpt.png" alt="assessemt_empty_img" />
                </div>
                <div className="_spDevPage--assessement-empty__infos_content">
                  <h5>Help employers get to know you</h5>
                  <p>
                    Everyone hates looking at resumes, but people LOVE seeing
                    you in person. Get more responses by telling us about you
                    via video.
                  </p>
                  {(props?.assementClicked || props?.assessementLoading) && (
                    <CircularProgress />
                  )}
                  {props?.dev?.userRef &&
                    !props?.assementClicked &&
                    !props?.assessementLoading && (
                      <button
                        onClick={props.onAnswerProfileQuestions}
                        disabled={props?.assementClicked}
                      >
                        Answer Profile Questions
                      </button>
                    )}
                </div>
              </div>
            </div>
          )}
        </div>

        <>
          {props?.showCross && (
            <>
              {props.vendorCrossVendor ? (
                <div className="column crossVendors">
                  <div className="row top togglebox">
                    {/* <h3 htmlFor="checked" className="vendor-info"></h3> */}
                    <h3 htmlFor="checked" className="vendor-info">
                      Match this resource with other Partners
                    </h3>
                    <div
                      className="row switch_box"
                      style={{ columnGap: ".5rem" }}
                    >
                      {/* <h4>Off</h4> */}
                      <SwitchComponent
                        id="crossVendors"
                        name="crossVendors"
                        checked={props.dev?.crossVendor ?? true}
                        change={(e) => props.onToggle(e, "crossVendor")}
                      ></SwitchComponent>
                      {/* <h4 style={{color:"#E3165B", fontWeight:"600"}}>On</h4> */}
                    </div>
                  </div>
                  <div className="bottom">
                    <p>
                      If you have selected the "Cross Vendor" option under your
                      Account Page, you can select here if you want this
                      resource to be matched with other Partners or not.
                    </p>
                  </div>
                </div>
              ) : (
                <></>
              )}
              <div className="column discovery">
                <div className="row top togglebox">
                  {/* <h3 htmlFor="checked" className="vendor-info"></h3> */}
                  <h3 htmlFor="checked" className="vendor-info">
                    Feature this resource
                  </h3>
                  <div
                    className="row switch_box"
                    style={{ columnGap: ".5rem" }}
                  >
                    {/* <h4>Off</h4> */}
                    <SwitchComponent
                      id="isfeatured"
                      name="featured"
                      checked={props?.dev?.featured ?? false}
                      change={(e) => props.onToggle(e, "featured")}
                    ></SwitchComponent>
                    {/* <h4 style={{color:"#E3165B", fontWeight:"600"}}>On</h4> */}
                  </div>
                </div>
                <div className="bottom">
                  <p>
                    This resource will be featured on your Sprytelabs.com
                    profile page
                  </p>
                </div>
              </div>
              {props.vendor?.settings?.ops?.discovery ? (
                <div className="column discovery">
                  <div className="row top togglebox">
                    {/* <h3 htmlFor="checked" className="vendor-info"></h3> */}
                    <h3 htmlFor="checked" className="vendor-info">
                      Make this resource discoverable to your entire
                      Organisation
                    </h3>
                    <div
                      className="row switch_box"
                      style={{ columnGap: ".5rem" }}
                    >
                      {/* <h4>Off</h4> */}
                      <SwitchComponent
                        id="isdiscoverable"
                        name="discovery"
                        checked={props.dev?.discovery ?? true}
                        change={(e) => props.onToggle(e, "discovery")}
                      ></SwitchComponent>
                      {/* <h4 style={{color:"#E3165B", fontWeight:"600"}}>On</h4> */}
                    </div>
                  </div>
                  <div className="bottom">
                    <p>
                      The Spryte Platform is made to work for large and small
                      partners alike. If you want this resource to be
                      discoverable to other users within your own Organisation,
                      leave this on. They can then be added on your internal
                      projects.
                    </p>
                  </div>
                </div>
              ) : (
                <></>
              )}

              <div className="column bookable">
                <div className="row top togglebox">
                  {/* <h3 htmlFor="checked" className="vendor-info"></h3> */}
                  <h3 htmlFor="checked" className="vendor-info">
                    Make this resource bookable on the Spryte Platform
                  </h3>
                  <div
                    className="row switch_box"
                    style={{ columnGap: ".5rem" }}
                  >
                    {/* <h4>Off</h4> */}
                    <SwitchComponent
                      id="isBookable"
                      name="leadTimeOn"
                      checked={props?.dev?.status}
                      change={(e) => props.onToggle(e, "status")}
                    ></SwitchComponent>
                    {/* <h4 style={{color:"#E3165B", fontWeight:"600"}}>On</h4> */}
                  </div>
                </div>
                <div className="bottom">
                  <p>
                    The Spryte Platform is made to work for many use cases. By
                    default all resources you add who have a profile completion
                    score of above 80% are bookable on the spryte platform by
                    our clients. If you would like to use the Spryte-Partner or
                    Spryte-Dev platforms for your own company needs, but have
                    resources which you don’t want to offer for booking, you may
                    toggle this option off for them.
                  </p>
                </div>
              </div>

              {props.vendor?.settings?.ops.leadTimeOn ? (
                <div className="column">
                  <div className="row top leadData">
                    {/* <h3 htmlFor="checked" className="vendor-info"></h3> */}

                    <div className="row left togglebox">
                      <h3 htmlFor="checkedLead" className="vendor-info">
                        Automatic Resource Lead Time
                      </h3>
                      <div
                        className="row switch_box"
                        style={{ columnGap: ".5rem" }}
                      >
                        {/* <h4>Off</h4> */}
                        <SwitchComponent
                          id="checkedLead"
                          name="leadTimeOn"
                          checked={props.dev?.leadTime?.leadTimeOn ?? true}
                          change={(e) => {
                            props.onToggle(e, "leadTime");
                            setIsLeadOn(e.checked);
                          }}
                        ></SwitchComponent>
                        {/* <h4 style={{color:"#E3165B", fontWeight:"600"}}>On</h4> */}
                      </div>
                    </div>
                    {isLeadOn ? (
                      <div className="row right leadData_time">
                        <h3 className="vendor-info">Lead Time(days)</h3>

                        <InPlaceEditorComponent
                          className="inPlaceEditor"
                          actionBegin={(e) => props.updateDevData(e.data)}
                          id="textboxEle"
                          name="leadDays"
                          mode="Inline"
                          type="Numeric"
                          // value={15}
                          value={props.dev?.leadTime?.leadDays ?? 15}
                          model={{ min: 1, max: 19, format: "N0" }}
                        ></InPlaceEditorComponent>
                      </div>
                    ) : (
                      <div className="row right leadData_time">
                        <h3
                          className="vendor-info"
                          style={{ color: "#A2A8B4" }}
                        >
                          Lead Time(days)
                        </h3>
                        <p style={{ color: "#A2A8B4" }}>
                          {props.dev?.leadTime?.leadDays ?? 15}
                        </p>
                      </div>
                    )}
                  </div>

                  <div className="bottom">
                    <p>
                      {" "}
                      If you don't want your resources to be immediatly booked
                      (for tomorrow as an example), you can set a lead time.
                      Setting a lead time of 15 days for example, will ensure
                      that all your resources who have the lead time flag set
                      will be undiscoverable and not booked until 15 days from
                      today. This is automatically applied every day so that you
                      don't have to manage availability precisely to the day on
                      the platform.
                    </p>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </>
          )}
        </>

        <div className="_sppdevAvail">
          <AvailabilityTemplate args={props?.dev} />
          <EligibilityTemplate args={props?.dev} />
        </div>
      </div>
    </div>
  );
};

export default CrossPlatform;
